import { newStepValue } from "../../../../../../modules/flow/services/flowBuilder/utils/constants";

export const setVariable = {
    json: {
      action: {
        description: '',
        actionType: 'setVariable',
        actionParams: {
          variables: {
            '' : ''
          }
        },
        result: {
          success: newStepValue,
        },
        report: ''
      },
      type: 'action',
    },
    paths: [
      'action.description',
      'action.actionParams.variables',
      'action.result.#',
      'action.report'
    ],
    groups: [
      {
        Parameters: ['action.description', 'action.actionParams.variables'],
      },
      {
        Logic: ['action.result.#'],
      },
      {
        Analytics: ['action.report'],
      },
    ],
    layout: {
      description: {
        type: 'text',
        label: 'Description',
        validators: {
          required: true,
        },
      },
      variableName: {
        type: 'text',
        label: 'Variable Name',
        validators: {
          required: true,
        },
      },
      variableValue: {
        type: 'text',
        label: 'Variable Value',
        validators: {
          required: true,
        },
      },
      result: {
        dataType: 'keyValue',
        key: {
          attributes: {
            readonly: true,
          },
          type: 'text',
          label: '#',
        },
        value: {
          attributes: {},
          type: 'next',
          label: 'Point to',
        },
      },
    },
  };